import { connect } from "react-redux"
import { BaseLink, useRoute } from "react-router5"
import isAuthorized from "utils/funcs/isAuthorized"
import React from "react"
import { UserAvatar } from "./UserAvatar"
import { userFullname } from "../../methods/utils"
import NavBalance from "./nav/NavBalance"
import "pages/Styles/UIKit_v2.sass"

let Nav: any = function Nav(props: any) {
    const $router = useRoute()
    const userSession = props.$store.userSession
    const userName = userFullname(userSession)

    const tariffsRouteName = "packages-v2"
    const tariffsLabel = "Тарифы"
    const blackFridayEnabled = userSession?.black_friday_enabled || false

    const isActive = (name: string | string[]) =>
        Array.isArray(name) ? name.includes($router.route.name) : $router.route.name === name
    const btnClass = (name: string | string[], extra?: string) =>
        `profile-navigation__btn ${isActive(name) ? "profile-navigation__btn--active" : ""} ${extra || ""}`.trim()

    return isAuthorized() ? (
        <nav className="profile-navigation ui-kit-v2">
            <BaseLink router={$router.router} routeName="new-contract" routeParams={{ act: "list" }}>
                <button type="button" className={btnClass("new-contract")}>
                    Шаблоны
                </button>
            </BaseLink>
            <BaseLink router={$router.router} routeName="signed-contracts">
                <button type="button" className={btnClass(["signed-contracts", "contract"])}>
                    Выставленные
                </button>
            </BaseLink>
            <BaseLink router={$router.router} routeName={tariffsRouteName}>
                <button type="button" className={btnClass(["packages-v2", "tariffs"], "profile-navigation__btn--with-badge")} style={{ position: "relative" }}>
                    {tariffsLabel}
                    {blackFridayEnabled && (
                        <span className="profile-navigation__badge">
                            ЧП
                        </span>
                    )}
                </button>
            </BaseLink>
            <BaseLink router={$router.router} routeName="profile">
                <button type="button" className="profile-navigation__profile-btn">
                    <UserAvatar name={userName} size={40} isActive={isActive("profile")} />
                    <div className="profile-navigation__profile-info">
                        {userName && (
                            <>
                                <span className="profile-navigation__user-name">{userName}</span>
                                <NavBalance />
                            </>
                        )}
                    </div>
                </button>
            </BaseLink>
        </nav>
    ) : null
}

Nav = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({ $commitToStore: (data: any) => dispatch({ ...data, type: 'S' }) })
)(Nav)

export default Nav
